import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import userAPI from "../../api/UserApi";
import { clearAccessToken } from "../../api/axiosInstance";
import {
  LayoutDashboard,
  ShoppingBag,
  MapPin,
  User,
  Lock,
  LogOut,
} from "lucide-react";

const NAV_LINKS = [
  { to: "/users/dashboard", label: "Dashboard", Icon: LayoutDashboard },
  { to: "/users/orders", label: "My Orders", Icon: ShoppingBag },
  { to: "/users/addresses", label: "Addresses", Icon: MapPin },
  { to: "/users/account", label: "Account Details", Icon: User },
  { to: "/users/change-password", label: "Change Password", Icon: Lock },
];

function Sidebar() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");

  // Fetch from the same API as Account Details so name is always in sync
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await userAPI.getDetails();
        if (res.code === 200) {
          const data = res.data;
          const fullName =
            [data?.firstName, data?.lastName].filter(Boolean).join(" ") ||
            data?.name ||
            "";
          setUserName(fullName);
          setUserEmail(data?.email || "");
        }
      } catch (err) {
        // silently fail — fallback to "U" initial
      }
    };
    fetchUser();
  }, []);

  // Logout: always clear local state even if API call fails
  const logOut = async () => {
    try {
      await userAPI.logOut();
    } catch (err) {
      // intentionally ignored
    } finally {
      clearAccessToken();
      localStorage.removeItem("token");
      localStorage.removeItem("accessToken");
      navigate("/");
    }
  };

  const initials = userName
    ? userName
        .split(" ")
        .map((w) => w.charAt(0).toUpperCase())
        .slice(0, 2)
        .join("")
    : "U";

  return (
    <div className="vp-sidebar">
      {/* ── Avatar / Name ── */}
      <div className="vp-sidebar-avatar-wrap">
        <div className="vp-sidebar-initials">{initials}</div>
        <p className="vp-sidebar-name">{userName || "User"}</p>
        {userEmail && (
          <p
            className="vp-sidebar-sub"
            style={{ fontSize: "0.68rem", wordBreak: "break-all" }}
          >
            {userEmail}
          </p>
        )}
      </div>

      {/* ── Nav Links ── */}
      <nav>
        {NAV_LINKS.map(({ to, label, Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `vp-nav-link${isActive ? " active" : ""}`
            }
          >
            <Icon size={14} />
            {label}
          </NavLink>
        ))}

        <hr className="vp-nav-divider" />

        <button className="vp-nav-link vp-logout" onClick={logOut}>
          <LogOut size={14} />
          Logout
        </button>
      </nav>
    </div>
  );
}

export default Sidebar;
